import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

export type TPos = {
  id: number,
  name: string,
  uid: string,
  alias: string,
  address: string,
  is_active: boolean,
  storehouse_uid: string,
  company_id: number,
  storehouse_id: number,
  created_at: string
}
type TPosContext = {
  list: TPos[],
  currentItem: TPos,
  currentSelected: TPos,
  showModal: boolean
}
const initialState:TPosContext =  {
  list:[],
  currentItem:{
    name: '',
    uid: '',
    alias: '',
    id: 0,
    is_active: false,
    storehouse_uid: '',
    company_id: 0,
    storehouse_id: 0,
    created_at: '',
    address: ''
  },
  currentSelected:{
    name: '',
    uid: '',
    alias: '',
    address: '',
    id: 0,
    is_active: false,
    storehouse_uid: '',
    company_id: 0,
    storehouse_id: 0,
    created_at: ''
  },
  showModal:false
}
interface PosContextType {
  pos: TPosContext;
  updatePos: (newConfig: Partial<TPosContext>) => void;
}
interface PosProviderProps {
  children: ReactNode;
}

const PosContext = createContext<PosContextType>({pos:initialState,updatePos:()=>{}});

export const PosProvider:React.FC<PosProviderProps> = ({ children }) => {
  const [pos, setPos] = useState(initialState);
  const updatePos = useCallback((newConfig:Partial<TPosContext>) => {
    setPos((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);
  
  const contextValue = useMemo(() => ({
    pos,
    updatePos,
  }), [pos, updatePos]);

  return (
    <PosContext.Provider value={contextValue}>
      {children}
    </PosContext.Provider>
  );
};

export const usePos = () => {
  return useContext(PosContext);
};